<template>
    <div class="footer" v-show="hidshow">
        <template>
            <!-- <van-grid :gutter="8" :column-num='5' :icon-size="20" square :border="false">
				<van-grid-item v-for="(value,index) in datainfo" :key="index" :icon="index==ins?value.img:value.img2"
					:class="index==ins?'color1':'color2'" :text="value.name" @click="daohang(index)" />
			</van-grid> -->
            <van-tabbar
                v-model="active"
                style="border-color:#F5F5F5"
            >
                <van-tabbar-item
                    @click="daohang(index)"
                    :name="index"
                    :icon="index == ins ? value.img : value.img2"
                    v-for="(value, index) in datainfo"
                    :key="index"
                    > 
                    <span style="color: #646566;" :class="{'color1':value.id == ins}">{{ value.name }}</span> 
                    </van-tabbar-item
                >
            </van-tabbar>
        </template>
    </div>
</template>

<script>
export default {
    name: "Footer",
    data() {
        return {
            active:0,
            docmHeight: "0", //默认屏幕高度

            showHeight: "0", //实时屏幕高度

            hidshow: true, //显示或者隐藏footer,

            isResize: false, //默认屏幕高度是否已获取
            ins: 0,
            datainfo: [
                {
                    img: require("@/assets/img/home.png"),
                    img2: require("@/assets/img/home2.png"),
                    name: "首页",
                    id:0
                },
                {
                    img: require("@/assets/img/huodong2.png"),
                    img2: require("@/assets/img/huodong.png"),
                    name: "活动",
                    id:1
                },
                {
                    img: require("@/assets/img/duihuan2.png"),
                    img2: require("@/assets/img/duihuan.png"),
                    name: "兑换",
                    id:2
                },
                {
                    img: require("@/assets/img/faqi2.png"),
                    img2: require("@/assets/img/faqi.png"),
                    name: "发起",
                    id:3
                },
                {
                    img: require("@/assets/img/own2.png"),
                    img2: require("@/assets/img/own.png"),
                    name: "我的",
                    id:4
                },
            ],
        };
    },
    methods: {
        daohang(i) {
            this.ins = i;
            if (i == 0) {
                this.$router.push({
                    path: "/",
                    query: {
                        item: "0",
                    },
                });
            }
            if (i == 1) {
                this.$router.push({
                    path: "/activity",
                    query: {
                        item: "1",
                    },
                });
            }
            if (i == 2) {
                this.$router.push({
                    path: "/exchange",
                    query: {
                        item: "2",
                    },
                });
            }
            if (i == 3) {
                this.$router.push({
                    path: "/Initiate",
                    query: {
                        item: "3",
                    },
                });
            }
            if (i == 4) {
                this.$router.push({
                    path: "/mine",
                    query: {
                        item: "4",
                    },
                });
            }
        },
        //判断终端  对安卓端软键盘弹出，页面上移做处理
        downApp() {
            let ua = navigator.userAgent.toLowerCase();
            //Android终端
            let isAndroid =
                ua.indexOf("Android") > -1 || ua.indexOf("Adr") > -1; //Ios终端
            let isiOS = !!ua.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
            if (isWeixinBrowser()) {
                this.$router.push({
                    path: "/product",
                });
            } else {
                if (/(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)) {
                    //Ios
                } else if (/(Android)/i.test(navigator.userAgent)) {
                    //Android终端

                    // window.onresize监听页面高度的变化
                    window.onresize = () => {
                        return (() => {
                            if (!this.isResize) {
                                //默认屏幕高度
                                this.docmHeight =
                                    document.documentElement.clientHeight;
                                this.isResize = true;
                            }
                            //实时屏幕高度
                            this.showHeight = document.body.clientHeight;
                        })();
                    };
                    /* window.location = 'http://www.xyfan.top/app.apk' */
                }
            }

            function isWeixinBrowser() {
                return /micromessenger/.test(ua) ? true : false;
            }
        },
    },

    mounted() {
        //底部导航样式
        
        
    },
    created(){
        this.downApp();
        this.ins = this.$route.query.item;
        if(this.ins){
            this.active = this.ins
        }else{
            this.active = 0;
            this.ins = 0
        }
        this.daohang(this.ins)
        
       
    },
    watch: {
        showHeight: function () {
            if (this.docmHeight >= this.showHeight) {
                this.hidshow = false;
            } else {
                this.hidshow = true;
            }
        },
        $route(to,from){
            console.log(to);
            this.ins = to.query.item;
            this.daohang(this.ins) 
        }
    },
};
</script>

<style lang="less">
.footer {
    width: 100%;
    height: 1.54rem;
    background: #F5F5F5;
    position: fixed;
    z-index: 50;
    bottom: 0;
    border:0;
    left: 0;

    p {
        margin-right: 1.38rem;
        float: left;
    }

    p:last-child {
        margin-right: 0;
    }

    img {
        display: block;
        width: 0.7rem;
    }

    .color1{
        color: #aa0018 !important;
    }

    // .color2 {
    //     color: #646566;
    // }
}
</style>
<style>
/* .van-grid-item__content {
		background-color: #F5F5F5;
	} */
</style>
